import React from "react";
import { Container } from "../../../../components";
import { Text } from "@telia/teddy";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { FieldSet, Input } from "../../../../forms";
import { RapidForm } from "../../../../rapidform";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { getFormById } from "../../../state/selectors";
import TEXT from "../../../text-consts";
import "./RegisterPrepaidForm.less";

interface StateProps {
    prepaidForm: Form;
}

interface PersonalDetailsFormProps extends StateProps {
    onSubmitDetails: () => void;
}

const RegisterPrepaidForm: React.FC<PersonalDetailsFormProps> = ({ prepaidForm, onSubmitDetails }) => {
    return (
        <div className="prepaid-simcard">
            <Container className="prepaid-simcard__bankid-container" size="medium">
                <Text mb="100">{TEXT.REGISTRATION.SIMCARD.INGRESS}</Text>
                <div className="prepaid-simcard-form__image">
                    <img alt="Kontantkort" src="/shop/assets/img-static/prepaid/startpakke.svg" />
                </div>
                <RapidForm
                    id={FORM_ID.REGISTER_PREPAID}
                    action={"#"}
                    errors={prepaidForm.errors}
                    values={prepaidForm.values}
                    visible={prepaidForm.visible}
                    started={prepaidForm.started}
                    onSubmit={onSubmitDetails}
                >
                    <FieldSet name="simCardAndPhoneNumber">
                        <>
                            <Input
                                className="prepaid-simcard-form__phone-field"
                                type="tel"
                                name={VALIDATION_FIELD.PRODUCT_USER_PHONE}
                                label={`${TEXT.REGISTRATION.SIMCARD.PHONE_NUMBER_INPUT_LABEL}:`}
                                data-di-mask
                            />
                            <Input
                                className="prepaid-simcard-form__simnumber-field"
                                type="tel"
                                name={VALIDATION_FIELD.PREPAID_SIM_NUMBER}
                                label={`${TEXT.REGISTRATION.SIMCARD.SIMCARD_INPUT_LABEL}:`}
                                data-di-mask
                            />
                        </>
                    </FieldSet>
                </RapidForm>
            </Container>
        </div>
    );
};
const mapStateToProps = (state: RootState): StateProps => ({
    prepaidForm: getFormById(state, FORM_ID.REGISTER_PREPAID),
});

export default connect(mapStateToProps)(RegisterPrepaidForm);
